import { isEmpty } from "lodash-es";
import Sockette from "sockette";
import { createEffect, createMemo, onCleanup } from "solid-js";
import type { ServerWebsocketMessage } from "~/rspc";
import { CARDS_STATE, USER_STATE } from "~/utils/app_state";
import { BASE_API_URL } from "~/utils/base_url";

export const WebsocketHandler = () => {
	let userId = createMemo(() => USER_STATE().user?.id);
	let ws: Sockette | null = null;
	createEffect(() => {
		if (ws) {
			ws?.close();
		}
		if (userId()) {
			let url_base = BASE_API_URL!.replace("http", "ws").replace("https", "wss");
			let url = `${url_base}/api/ws?user_id=${userId()}`;
			ws = new Sockette(url, {
				timeout: 5e3,
				maxAttempts: 10,
				onopen: (_e) => {},
				onmessage: (e) => {
					let message: ServerWebsocketMessage = JSON.parse(e.data);
					if (message === "Ping") {
					}
					if (typeof message === "object") {
						let cardGenerated = "CardGenerated" in message && message.CardGenerated;
						let userStatus = "UserStatus" in message ? message.UserStatus : null;
						if (cardGenerated) {
							CARDS_STATE().addCard(cardGenerated.card);
							if (!isEmpty(CARDS_STATE().reviewState.activeQueue)) {
								CARDS_STATE().reviewState.activeQueue.push({ card: cardGenerated.card });
							}
						}
						if (userStatus) {
							USER_STATE().quick((_s) => {
								CARDS_STATE().processingState.processingGames =
									userStatus.status.processing_games ?? 0;
								CARDS_STATE().processingState.processingCards =
									userStatus.status.processing_cards ?? 0;
								CARDS_STATE().processingState.isFetching = userStatus.status.fetching_games;
							});
						}
					}
				},
				onreconnect: (_e) => {},
				onmaximum: (_e) => {},
				onclose: (_e) => {},
				onerror: (_e) => {},
			});
		}
	});
	onCleanup(() => ws?.close());

	return null;
};
